





























import { Component, Vue } from 'vue-property-decorator';
import { keycloakAuthService } from '@/services/keycloakAuth';
import {notification} from "ant-design-vue";

@Component
export default class AuthCallback extends Vue {
    async mounted() {
        try {
            const code = this.$route.query.code as string;
            const state = this.$route.query.state as string;

            if (!code || !state) {
                notification.error({
                    message: this.$t('authCallback.errorKeycloakCodeState') as string,
                    description: '',
                    duration: 3,
                });

                setTimeout(() => {
                    keycloakAuthService.clearData();

                    window.location.replace('/login');
                }, 3000);
            }

            keycloakAuthService.getTokensByCodeAndState(code, state).then(() => {
                this.$http.get('/api/users/permissions')
                    .then(({ data }) => {
                        localStorage.setItem('userData', JSON.stringify(data));
                    })
                    .then(() => {
                        setTimeout(() => {
                            window.location.replace('/');
                        }, 2000);
                    }).catch(() => {
                        keycloakAuthService.logout().finally(() => {
                            notification.error({
                                message: this.$t('authCallback.errorPermissions') as string,
                                description: '',
                                duration: 7,
                            });

                            setTimeout(() => {
                                window.location.replace('/login');
                            }, 3000);
                        });
                    });
            });
        } catch (error) {
            notification.error({
                message: this.$t('authCallback.errorKeycloak') as string,
                description: '',
                duration: 3,
            });

            setTimeout(() => {
                keycloakAuthService.clearData();

                window.location.replace('/login');
            }, 3000);
        }
    }
}
